import { createFileRoute } from "@tanstack/react-router";
import { LoginCard } from "@/components/login-card";

export const Route = createFileRoute("/admin/login")({
  ssr: false,
  head: () => ({ meta: [{ title: "Platform Admin — Sign in" }] }),
  component: AdminLogin,
});

function AdminLogin() {
  return (
    <LoginCard
      title="Platform Admin"
      subtitle="Operator console for Studio OS SaaS"
      audience="admin"
      allowedRoles={["superadmin"]}
      demoAccounts={[{ label: "Superadmin", email: "admin@platform.test" }]}
      redirectTo="/admin"
    />
  );
}
